export default "__VITE_ASSET__BpcLWUWp__"